import React from "react";
import { SettingOutlined, TransactionOutlined, AppstoreOutlined, AppstoreAddOutlined } from "@ant-design/icons";

import paths from "./paths";

const navMenuConfig = [
    {
        label: "Quản lý ứng dụng",
        icon: <AppstoreOutlined />,
        path: paths.appManagementList,
    },
    {
        label: "Quản lý Super App",
        icon: <AppstoreAddOutlined />,
        path: paths.superAppList,
    },
    {
        label: "Quản lý giao dịch",
        icon: <TransactionOutlined />,
        children: [
            {
                label: "SMS",
                path: paths.smsList,
            },
        ],
    },
    {
        label: "Cài đặt",
        icon: <SettingOutlined />,
        children: [
            {
                label: "Cài đặt tin nhắn",
                path: paths.smsConfig,
            },
        ],
    },
];

export default navMenuConfig;
